<template>
  <FactureCard>
    <template v-slot:title>Paiement</template>
    <p class="solde">Solde: <span class="solde--montant">{{ formatPrix(solde) }}</span></p>

    <div class="inputFields" v-if="inputFields">
      <v-text-field label="Numéro de carte" outlined placeholder="1234 1234 1234 1234" dense append-icon="mdi-credit-card" v-model="carte.numeroCarte"></v-text-field>
      <v-text-field label="Expiration" outlined placeholder="MM / AA" dense append-icon="mdi-calendar-range" v-model="carte.expiration"></v-text-field>
      <v-text-field label="CVV" outlined dense placeholder="123" append-icon="mdi-numeric" v-model="carte.cvv"></v-text-field>
    </div>
    <slot name="btn-paiement">
      <v-btn rounded color="success" @click="payerClicked">Payer</v-btn>
    </slot>
  </FactureCard>
</template>

<script>
import FactureCard from "./FactureCard"
export default {
  components: { FactureCard },
  data(){
    return {
      carte: {
        numeroCarte: '',
        expiration: '',
        cvv: ''
      }
    }
  },
  props: {
    inputFields: {
      type: Boolean,
      default: false
    },
    formatPrix: {
      type: Function
    },
    solde: Number
  },
  methods: {
    payerClicked(){
      this.$emit('payerClicked', this.carte)
    }
  }
}
</script>

<style scoped>
.solde {
  font-size: 1.5em;
}
.solde--montant {
  font-weight: bold;
}
</style>